/**
 * Created by Jan Bradac on 14.5.2016.
 */

(function (Lfl, $, undefined) {
    if(Lfl.Files.isLoadedAlready(Lfl, 'String')) {
        return;
    }

    /*
     |==============================================================================================================
     | Documentation
     |==============================================================================================================
     */

    /**
     * Provides helper functions to manipulate strings.
     *
     * @memberOf Lfl
     */
    Lfl.String;

    (function (String, $, undefined) {

        /*
         |===========================================================================================================
         | Object definition
         |===========================================================================================================
         */

        /*
         |-----------------------------------------------------------------------------------------------------------
         | Public methods
         |-----------------------------------------------------------------------------------------------------------
         */

        /*
         |-------------------------------------------------------------------------
         | Cases conversion
         | Taken from (mostly comments on) http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/ */


        /**
         * @memberOf Lfl.String
         * @return {string}
         */
        String.trim = function(string){
            return string.replace(/^\s+|\s+$/g, "");
        };

        /**
         * @memberOf Lfl.String
         * @return {string}
         */
        String.toCamel = function(string){
            return string.replace(/([-_][a-z])/g, function($1){return $1.toUpperCase().replace(/[-_]/,'');});
        };

        /**
         * @memberOf Lfl.String
         * @return {string}
         */
        String.toKebab = function(string){
            return string.replace(/([A-Z])/g, function($1, p1, pos){return (pos > 0 ? "-" : "") + $1.toLocaleLowerCase();});
        };

        /**
         * @deprecated Use toKebab() instead.
         * @memberOf Lfl.String
         * @return {string}
         */
        String.toDash = function(string){
            return this.toKebab(string);
        };

        /**
         * @memberOf Lfl.String
         * @return {string}
         */
        String.toUnderscore = function(string){
            return string.replace(/([A-Z])/g, "_$1").replace(/^_/,'').toLocaleLowerCase();
        };

        /**
         * @memberOf Lfl.String
         * @return {string}
         */
        String.capitalizeFirstLetter = function(string){
            return string.charAt(0).toLocaleUpperCase() + string.slice(1);
        };

        /*
        |----------------------------------------------------------------------------------------
        | Type conversion
        |----------------- */

        /**
         * Converts members of an array to strings.
         *
         * @memberOf Lfl.String
         * @return {string}
         */
        String.convertValuesToStrings = function(values) {
            return _.map(values, function (value) {
                return value + '';
            });
        }

        /*
         |-----------------------------------------------------------------------------------------------------------
         | Private methods
         |-----------------------------------------------------------------------------------------------------------
         */

    }(Lfl.String = Lfl.String || {}, jQuery));
}(window.Lfl = window.Lfl || {}, jQuery));
